(() => {
  const init = (gallery) => {
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('[data-p5-track]');
    const slides = [...gallery.querySelectorAll('[data-p5-slide]')];
    const dots = [...gallery.querySelectorAll('[data-p5-dot]')];
    if (!track || slides.length < 2) return;
    let active = 0;
    const show = (next) => {
      active = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${active * 100}%)`;
      dots.forEach((dot, index) => dot.setAttribute('aria-current', index === active ? 'true' : 'false'));
    };
    gallery.querySelector('[data-p5-prev]')?.addEventListener('click', () => show(active - 1));
    gallery.querySelector('[data-p5-next]')?.addEventListener('click', () => show(active + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
  };
  document.querySelectorAll('[data-p5-gallery]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-p5-gallery]')));
})();
